/* eslint-disable no-console */
import type { PaymentIQGeneralSettings } from 'apps/core/types/web-storage.types';
import { WebStorageKeys } from 'apps/core/vars/web-storage';

export const setPaymentIqGeneralSettings = (newValue: PaymentIQGeneralSettings): void => {
  const currentSettings: PaymentIQGeneralSettings | undefined = getWebStorage(
    WebStorageKeys.PAYMENTIQ_GENERAL_SETTINGS,
  );
  setWebStorage(WebStorageKeys.PAYMENTIQ_GENERAL_SETTINGS, {
    ...(currentSettings || {}),
    ...newValue,
  });
};

export const getWebStorage = <T>(key: string): T | undefined => {
  const data: string | null = sessionStorage.getItem(key) || localStorage.getItem(key);
  try {
    return data ? (JSON.parse(data) as T) : undefined;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

export const setWebStorage = <T>(key: string, value: T | string | number | Record<string, unknown>): void => {
  const data: string = typeof value === 'string' ? value : JSON.stringify(value);
  sessionStorage.setItem(key, data);
  localStorage.setItem(key, data);
};

export const removeWebStorage = (key: string): void => {
  sessionStorage.removeItem(key);
  localStorage.removeItem(key);
};
